/* global IS_BOXED */
import * as Sentry from '@sentry/react';

import app from './react/app';
import './styles.js';

// IS_BOXED определяется в DefinePlugin webpack конфига
// Для boxed сборки Sentry не инициализируется
const isBoxed = typeof IS_BOXED !== 'undefined' && IS_BOXED;

if (!window.location.href.match(/127.0.0.1|localhost/)) {
  if (!isBoxed) {
    Sentry.init({
      dsn: 'https://8de4f12a0129ebe3ee3dadca91d44b17@sentry.wonderslide.com/1',
      environment: window.location.host === 'dev.wonderslide.com' ? 'develop' : 'production',
      tracesSampleRate: 0.2,
      normalizeDepth: 10,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.thirdPartyErrorFilterIntegration({
          filterKeys: ['wonderslide-com-key'],
          behaviour: 'drop-error-if-contains-third-party-frames',
        }),
      ],
    });
  } else {
    Sentry.init({
      dsn: 'https://3efe47ce55ec8f561c5631758a52da12@sentry.wonderslide.com/11',
      environment: 'production',
      tracesSampleRate: 0.2,
      normalizeDepth: 10,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.thirdPartyErrorFilterIntegration({
          filterKeys: ['roboslide-key'],
          behaviour: 'drop-error-if-contains-third-party-frames',
        }),
      ],
    });
  }

  console.debug(Sentry);
}

if (document.getElementById('root')) {
  app();
}
